<template>
    <div class="manage--left menu-manual" ref="lesson-left">
        <div v-if="!mobile" class="div-list-lessons" :class="{ht: !mobile}">
            <div v-for="(item, index) in general" :key="index">
                <div class="titleMenu" :class="[{isActive: item.id == activeID}]" v-on:click="changeItem({id: item.id, name: item.name})" >
                    <p>{{item.name}}</p>
                </div>
            </div>
        </div>
        <div v-else class="div-list-lessons-mobile" :class="{ht: !mobile}">
            <div v-for="(item, index) in general" :key="index">
                <div class="titleMenu" :class="[{isActive: item.id == activeID}]" v-on:click="changeItem({id: item.id, name: item.name})" >
                    <p>{{item.name}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                keyword: "",
                result: [],
                type: 0,
                activeID: 0,
                general: [],
                activeName: [0],
            };
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        watch: {},
        async created() {
            let temp = this.data.dataGeneral.filter(el => el.environment == this.$lang());
            this.general = temp[0].dataList;
        },
        methods: {
            changeItem: function (params) {
                this.activeID = params.id;
                this.$emit("changeItem", params);
                document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
            },
            toggleActive () {
                this.activeName = this.activeName.pop();
            }
        },
    };
</script>
<style scoped>
    .titleMenu {
        font-size: 16px;
        min-height: 25px;
        height: auto;
        display: flex;
        align-items: center;
        border-bottom: 1px solid;
        padding-left: 5px;
        line-height: 22px;
    }
    .isActive {
        background: #0071c5;
        color: #fff;
        border-radius: 6px;
    }
    .div-list-lessons-mobile {
        cursor: pointer !important;
        overflow: auto;
        height: 100% !important;
        /* border: 1px solid #e3e3e3; */
        margin-top: unset;
        padding-bottom: 0;
    }


    /* ---------------------- */
    .lkt-collapse-item {
        padding-bottom:0 !important;
    }
    .headerMenu {
        border-radius: unset !important;
        text-align: center;
    }
    .headerMenu:hover {
        background: none !important;
        cursor: none;
    }
    .headerMenu b {
        color: red !important;
        font-size: 12pt;
    }
    .collapse-title {
        font-size: 14pt;
        color: #000 !important;
        background: unset !important;
    }
    .el-collapse {
        border: none;
    }
    .lkt-height-div {
        height: 30px;
    }
    .lkt-icon-present-absent {
        width: 50px;
    }
    .inputDate {
        max-width: 129px !important;
    }
    .el-col-2 {
        margin-top: 5px;
        text-align: center;
    }
    .el-form-item {
        padding: 0px !important;
        margin-bottom: 0px !important;
    }
    .button--search--left {
        width: auto;
        /* height: auto; */
    }
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
    }
    .btn_download {
        background: transparent;
        border: none;
        border-radius: 5px;
        margin-left: 2px;
    }
    .btn_download:hover {
        background: #d7d7d7;
    }
    /* custom */
    .div-list-lessons {
        /* border: 1px solid #e3e3e3; */
        /* padding: 5px; */
        /* border-radius: 5px; */
        margin-top: unset;
        padding-bottom: 0;
    }
    .ht {
        /* height: calc(100% - 80px)!important; */
        height: 100% !important;
        padding-top: 0 !important;
    }
    .nqt--list--lessons {
        border-bottom: 1px solid #e3e3e3;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons b {
        color: #0071c5;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons {
        color: #000;
        border-radius: 10px;
    }
    /* .nqt--list--lessons.active, .nqt--list--lessons b:hover {
        background: #0071c5;
        color: #fff !important;
        border-radius: 10px;
    } */
    .active {
        color: #fff !important;
    }
    .active b {
        color: #fff;
    }
    .active:hover {
        background: #0071c5;
    }
    .manage--left {
        /* box-shadow: none;
        padding-top: 0;
        padding-bottom: 0; */
        padding: 10px;
        border: none;
        border: 1px solid #e3e3e3;
    }
    .search--type {
        display: flex;
        justify-content: center;
        height: 36px;
        margin-bottom: 5px;
    }
    .search--type--btn {
        border: 0;
        color: #e3e3e3;
        font-size: 12px;
        width: 50%;
        background: transparent;
        font-weight: 300;
    }
    .search--type--btn.active--nqt {
        color: #0071c5;
        border-bottom: 2px solid #0071c5;
    }
    @media (max-width: 480px) {
        .inputDate {
            width: calc(50% - 13px);
            max-width: 100% !important;
            -webkit-appearance: none;
            -moz-appearance: none;
        }
        .el-date-editor.el-input .el-input__inner {
            width: 154px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/faq/left_faq.vue